import React from "react";
import ToggleOrderAttachmentDialog from "../../../common/Buttons/_ToggleOrderAttachmentDialog";

export const _columns = [
  {
    key: "storagesByOrderId.nodes",
    name: "File",
    isIconOnly: false,
    fieldName: "storagesByOrderId.nodes",
    isResizable: true,
    minWidth: 35,
    maxWidth: 55,
    isPadded: false,
    onRender: item => {
      return <ToggleOrderAttachmentDialog buttonType="action" item={item} />;
    }
  },
  {
    key: "pickupDate",
    name: "Pickup date",
    fieldName: "pickupDate",
    minWidth: 100,
    maxWidth: 100,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "item.relationByShipperId.name",
    name: "Shipper",
    fieldName: "item.relationByShipperId.name",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: true,
    isPadded: false,
    onRender: item => {
      return <div>{item.relationByShipperId.name}</div>;
    }
  },
  {
    key: "shipmentByShipmentId",
    name: "Loaded to truck",
    fieldName: "shipmentByShipmentId",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: true,
    isPadded: false,
    onRender: item => {
      return (
        <div>
          {item.shipmentByShipmentId.carrierByCarrierId.truck +
            "-" +
            item.shipmentByShipmentId.carrierByCarrierId.trailer}
        </div>
      );
    }
  },

  {
    key: "relationBySellerId.code",
    name: "Seller",
    fieldName: "relationBySellerId.code",
    minWidth: 150,
    maxWidth: 200,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: true,
    isPadded: false,
    onRender: item => {
      return <div> {item.relationBySellerId.code} </div>;
    }
  },
  // {
  //   key: "relationByBuyerId.code",
  //   name: "Buyer",
  //   fieldName: "relationByBuyerId.code",
  //   minWidth: 100,
  //   maxWidth: 120,
  //   isResizable: true,
  //   isRowHeader: true,
  //   isSorted: false,
  //   isSortedDescending: false,
  //   isPadded: false,
  //   onRender: item => {
  //     return <div> {item.relationByBuyerId.name} </div>;
  //   }
  // },
  {
    key: "packingCode",
    name: "Packing code",
    fieldName: "packingCode",
    minWidth: 100,
    maxWidth: 170,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "boxes",
    name: "Boxes",
    fieldName: "boxes",
    minWidth: 50,
    maxWidth: 50,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "boxesControle",
    name: "B.C.",
    fieldName: "boxesControle",
    minWidth: 50,
    maxWidth: 50,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "brutto",
    name: "Brutto",
    fieldName: "brutto",
    minWidth: 40,
    maxWidth: 50,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "c8",
    name: "Chargeable",
    fieldName: "chargableWeight",
    minWidth: 40,
    maxWidth: 50,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "awb",
    name: "AWB",
    fieldName: "awb",
    minWidth: 120,
    maxWidth: 160,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "flight",
    name: "Flight",
    fieldName: "flight",
    minWidth: 60,
    maxWidth: 70,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "cargoTypeByCargoTypeId.code",
    name: "Cargo",
    fieldName: "cargoTypeByCargoTypeId.code",
    minWidth: 50,
    maxWidth: 50,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.cargoTypeByCargoTypeId.code}</div>;
    }
  },
  {
    key: "packingTypeByPackingId.type",
    name: "Packing",
    fieldName: "packingTypeByPackingId.type",
    minWidth: 80,
    maxWidth: 80,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <div>{item.packingTypeByPackingId.type}</div>;
    }
  },
  {
    key: "amountPallets",
    name: "Pallets",
    fieldName: "amountPallets",
    minWidth: 60,
    maxWidth: 60,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false
  },
  {
    key: "countryByCountryId.iso",
    name: "Origin",
    fieldName: "countryByCountryId.iso",
    minWidth: 60,
    maxWidth: 60,
    isResizable: true,
    isRowHeader: true,
    isSorted: false,
    isSortedDescending: false,
    isPadded: false,
    onRender: item => {
      return <span>{item.countryByCountryId.iso}</span>;
    }
  }
];



// WEBPACK FOOTER //
// ./src/views/Orders/Table/_OrdersTableColumns.js